import { useQuery } from 'react-query'
import { capitalize } from 'lodash'

import { useAuthedFetch } from '../auth/useAuthedFetch'
import withFetchCancel from '../libs/withFetchCancel'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

export const useOriginCountries = config => {
  const authedFetch = useAuthedFetch()

  const query = useQuery(
    'originCountries',
    () =>
      withFetchCancel(signal =>
        authedFetch('GET', `${BACKEND_ENDPOINT}/available_origin_countries`, {
          parseJSON: true,
          signal,
        }),
      ),
    {
      select: ({ data }) => data,
      ...config,
    },
  )

  return query
}
